var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":"","small":""},on:{"click":_vm.onAdd}},[_c('v-icon',{staticClass:"mr-1",attrs:{"large":""}},[_vm._v("mdi-plus")]),_vm._v(" "+_vm._s(_vm.buttonText)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }